import React, { useState } from "react";
import { Message, Button, Icon, Table } from "semantic-ui-react";

import moment from "moment";
import { handleUpdateMutuelle, getMutuelleForOneUser } from "../../Api/api";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";
import { useNavigate, useLocation } from "react-router-dom";
import SpeedDialComponent from "../../SpeedDial/SpeedDialComponent"


function MutuelleAct(props) {
  const [visible, setVisible] = useState(true);
  const PatientelleGridState = useSelector(selectPatientelleGrid);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    idpatient,
    commentaire_sur_patient,
    civilite,
    prenom,
    nom,
    date_naissance,
  } = PatientelleGridState;
  sessionStorage.setItem("ID_Session", idpatient);

  const { data, refetch } = useQuery("MutuellePatient", () =>
    getMutuelleForOneUser(idpatient)
  );

  const mutation = useMutation(
    (data) => {
      handleUpdateMutuelle(data);
    },
    {
      onSuccess: () => {
        toast.success("Successfully updated", {
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => refetch(), 300);
      },
      onError: () => {
        console.log("error");
      },
    }
  );

  let date = moment().format("DD-MM-YYYY");

  const handleDismiss = () => {
    setVisible(false);
  };
  let ImportantMessage;

  if (commentaire_sur_patient && visible === true) {
    ImportantMessage = (
      <Message color="red" onDismiss={handleDismiss}>
        <Message.Header>Important!</Message.Header>
        {commentaire_sur_patient}
      </Message>
    );
  }

  return (
    <div style={{ minHeight: "99.6vh" }}>
      <br></br>
      <h1 style={{ textAlign: "center" }}>
        Vous pouvez remplir une ou plusieurs mutuelles
      </h1>
      <h3 style={{ textAlign: "center" }}>
        JE SUIS {civilite} {nom} {prenom} <br></br> Date de naissance :{" "}
        {date_naissance}
      </h3>

      {location.pathname === "/" ? (
        <h3 style={{ textAlign: "center" }}>
          Voici mes prestations pour le {date} :
        </h3>
      ) : null}
      <br></br>
      {ImportantMessage}
      <br></br>
      <Table
        celled
        fixed
        singleLine
        striped
        selectable
        textAlign="center"
      // collapsing
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Date de consultation</Table.HeaderCell>
            <Table.HeaderCell>Actes</Table.HeaderCell>
            <Table.HeaderCell>Somme des actes</Table.HeaderCell>
            <Table.HeaderCell>Reste à payer</Table.HeaderCell>
            <Table.HeaderCell>Mutuelle faite</Table.HeaderCell>
            <Table.HeaderCell>Modifié le</Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data?.data?.map(
            (
              {
                date_consultation,
                nom_acte,
                sum_act,
                rest,
                mutuelle_updated_at,
                mutuelle_faite,
                date_consultation_For_Server,
                fk_id_patient1,
              },
              idx
            ) => (
              <Table.Row key={idx}>
                <Table.Cell>{date_consultation}</Table.Cell>
                <Table.Cell>{nom_acte}</Table.Cell>
                <Table.Cell>{sum_act}</Table.Cell>
                <Table.Cell
                  className={
                    rest === 0
                      ? "paid"
                      : rest > 0
                        ? "unpaid"
                        : rest < 0
                          ? "overPaid"
                          : null
                  }
                >
                  {rest === 0 ? (
                    <Icon name="checkmark" color="green" size="large" />
                  ) : rest > 0 ? (
                    <Icon name="attention" color="red" size="large" />
                  ) : rest < 0 ? (
                    <Icon name="close" color="black" size="large" />
                  ) : null}
                  {rest}
                </Table.Cell>
                <Table.Cell>{mutuelle_faite === 0 ? "Non" : "Oui"}</Table.Cell>
                <Table.Cell>{mutuelle_updated_at}</Table.Cell>
                <Table.Cell>
                  {mutuelle_faite === 0 ? (
                    <Button
                      animated
                      positive
                      onClick={() => {
                        mutation.mutate({
                          fk_id_patient1,
                          date_consultation_For_Server,
                          mutuelle_faite,
                        });
                      }}
                    >
                      <Button.Content visible>Remplir</Button.Content>
                      <Button.Content hidden>
                        <Icon
                          name="edit outline"
                          className="IconFix"
                          size="big"
                        />
                      </Button.Content>
                    </Button>
                  ) : (
                    <Button
                      animated
                      color="orange"
                      onClick={() => {
                        mutation.mutate({
                          fk_id_patient1,
                          date_consultation_For_Server,
                          mutuelle_faite,
                        });
                      }}
                    >
                      <Button.Content visible>Ne pas remplir</Button.Content>
                      <Button.Content hidden>
                        <Icon
                          name="edit outline"
                          className="IconFix"
                          size="big"
                        />
                      </Button.Content>
                    </Button>
                  )}
                </Table.Cell>
              </Table.Row>
            )
          )}
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell colSpan="6">
              <Button
                floated="right"
                color="violet"
                onClick={() => navigate(-1)}
              >
                Retour
              </Button>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      <br />
      <br />
      <br />
      <SpeedDialComponent />
    </div>
  );
}

export default MutuelleAct;
